var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 23,
  viewBox: "0 0 21 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.15999 23L0 0L21 9.93955L9.53074 12.4795L4.15999 23ZM3.43468 4.4966L5.3366 15.0105L7.79307 10.2009L13.037 9.04072L3.43468 4.4966Z",
  fill: "#ffffff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow.6a14413882596c70b8f47af99fbccd84.svg";